"use client";

import { ComponentType, ReactNode, useEffect, useState } from "react";

import { Skeleton } from "@/components/ui/Skeleton";
import { useAppContext } from "@/context/AppContext";

export function AuthenticatedHomeGate({ children }: { children: ReactNode }) {
  const { isLoggedIn } = useAppContext();
  const [Dashboard, setDashboard] = useState<ComponentType | null>(null);

  useEffect(() => {
    if (!isLoggedIn || Dashboard) return;

    void import("@/components/index/HomeLandingContent").then((module) => {
      setDashboard(() => module.HomeLandingContent);
    });
  }, [Dashboard, isLoggedIn]);

  if (!isLoggedIn) return children;

  if (!Dashboard) {
    return (
      <main
        className="app-page-section min-h-[60vh] bg-background"
        aria-busy="true"
      >
        <div className="app-page-container" aria-hidden="true">
          <div className="space-y-3">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-10 max-w-sm" />
          </div>
          <div className="app-page-main-grid mt-6">
            <Skeleton className="min-h-80 rounded-2xl" />
            <Skeleton className="min-h-80 rounded-2xl" />
            <Skeleton className="min-h-64 rounded-2xl xl:col-span-2" />
          </div>
        </div>
      </main>
    );
  }

  return <Dashboard />;
}
